var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"block"},[_c('el-slider',{model:{value:(_vm.percentage),callback:function ($$v) {_vm.percentage=$$v},expression:"percentage"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }